/**
 * Constants shared by the nutrition plan view. Values mirror the mobile app
 * (`PrecisionReactNative/src/modules/nutrition`) so both clients render the
 * same plan the same way.
 */

/** Shown when a food or recipe has no `photo_url`. */
export const DEFAULT_MEAL_IMAGE =
  "https://assets.precision.care/static_content/recipes/no_picture_available.jpg";

/** kcal per gram of each macronutrient. */
export const MACRO_KCAL = {
  carbs: 4,
  protein: 4,
  fat: 9,
} as const;

/** Meal score bands: Low 0–35, Moderate 36–59, High 60+. */
export const SCORE_THRESHOLDS = {
  lowMax: 35,
  moderateMax: 59,
} as const;

/** Calorie deviations below this (kcal) are not called out in the intake view. */
export const CALORIE_DEVIATION_THRESHOLD = 50;
